export interface Manhua {
  id: string;
  title: string;
  category: string;
  tags: string[];
  rating: number;
  status: string;
  latestChapter: string;
  updateTime: string;
  views: string;
  cover: string;
  intro: string;
  author: string;
  chapters: number;
}

export interface ShuYuan {
  id: string;
  name: string;
  tag: string;
  desc: string;
  updateSpeed: string;
  stability: number;
  free: boolean;
  download: boolean;
  url: string;
  icon: string;
}

export const categories: string[] = [
  "热血战斗",
  "奇幻冒险",
  "恋爱治愈",
  "都市现实",
  "悬疑惊悚",
  "重生逆袭",
  "校园青春",
  "轻松搞笑",
];

export const manhuaList: Manhua[] = [
  {
    id: "solo-leveling",
    title: "我独自升级",
    category: "热血战斗",
    tags: ["猎人", "升级流", "怪物"],
    rating: 9.6,
    status: "连载中",
    latestChapter: "第 236 话",
    updateTime: "今天 08:20 更新",
    views: "2850万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20dark%20fantasy%20hunter%20protagonist%20with%20glowing%20orange%20energy%20aura%20and%20neon%20sword%2C%20dramatic%20modern%20comic%20digital%20painting%2C%20clean%20warm%20gradient%20background%2C%20vertical%20portrait%20book%20cover%20composition&width=420&height=600&seq=cover-solo&orientation=portrait",
    intro: "十年前一次意外开启了通往异界的传送门，人类陷入被魔物侵袭的末世。最弱猎人成振宇在一次双重地下城任务中濒死觉醒，开启名为“玩家”的独特成长系统，从此踏上从底层逆袭为最强猎人的征程。",
    author: "Chugong · DUBU",
    chapters: 236,
  },
  {
    id: "omniscient-reader",
    title: "全知读者视角",
    category: "奇幻冒险",
    tags: ["小说改编", "末日", "群像"],
    rating: 9.5,
    status: "连载中",
    latestChapter: "第 198 话",
    updateTime: "昨天 21:40 更新",
    views: "2310万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20stoic%20male%20protagonist%20holding%20an%20open%20book%20with%20glowing%20golden%20light%20and%20stars%2C%20apocalyptic%20city%20silhouette%2C%20modern%20manhwa%20painting%2C%20warm%20amber%20and%20charcoal%20tones%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-omnir&orientation=portrait",
    intro: "平凡上班族金独子沉迷连载小说《灭世之路》，当小说中的末日降临现实，唯有他是全知全能的读者。他必须依靠对小说的记忆，带领众多配角改写既定的悲剧结局。",
    author: "singNsong · Sleepy-C",
    chapters: 198,
  },
  {
    id: "sweet-home",
    title: "甜蜜之家",
    category: "悬疑惊悚",
    tags: ["怪物", "末世", "人性"],
    rating: 9.3,
    status: "已完结",
    latestChapter: "全 140 话",
    updateTime: "3 天前更新",
    views: "1980万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20teenage%20boy%20in%20empty%20dark%20apartment%20facing%20shadowy%20monster%20silhouette%2C%20moody%20orange%20and%20teal%20lighting%2C%20horror%20thriller%20comic%20style%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-sweethome&orientation=portrait",
    intro: "宅男贤秀蜗居在一栋破旧公寓，当窗外世界被怪物占领、人类开始异变成欲望的化身，他被迫与陌生的邻居们并肩求生。在绝境中，每个人隐藏的欲望与善意都被一一揭开。",
    author: "Kim Carnby · Hwang Youngchan",
    chapters: 140,
  },
  {
    id: "true-beauty",
    title: "女神降临",
    category: "恋爱治愈",
    tags: ["化妆", "校园", "治愈"],
    rating: 9.2,
    status: "已完结",
    latestChapter: "全 220 话",
    updateTime: "1 周前更新",
    views: "3120万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20beautiful%20young%20woman%20with%20makeup%20holding%20mirror%20and%20lipstick%2C%20soft%20pastel%20coral%20and%20cream%20tones%2C%20romance%20romantic%20comedy%20manhwa%20style%2C%20clean%20background%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-truebeauty&orientation=portrait",
    intro: "因为素颜饱受欺凌的林珠京学会了高超的化妆技巧，成为校内外公认的女神。然而卸下妆容的真实自我，与一眼看穿她素颜的帅气学霸之间，展开了一段关于真实与美丽的青春恋爱。",
    author: "Yaongyi",
    chapters: 220,
  },
  {
    id: "love-revolution",
    title: "恋爱革命",
    category: "校园青春",
    tags: ["校园", "甜蜜", "搞笑"],
    rating: 9.0,
    status: "已完结",
    latestChapter: "全 260 话",
    updateTime: "2 周前更新",
    views: "1760万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20cheerful%20teen%20boy%20and%20girl%20with%20backpacks%20in%20school%20uniform%2C%20bright%20sunny%20sky%20background%2C%20energetic%20colorful%20coral%20and%20amber%20tones%2C%20youthful%20romance%20comedy%20style%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-loverevo&orientation=portrait",
    intro: "对女主角一见钟情的元气少年孔正云，用最直球又笨拙的方式发起恋爱攻势。从校服到日常，两个性格截然不同的少男少女在欢笑与泪水中一起成长。",
    author: "232",
    chapters: 260,
  },
  {
    id: "returners-revenge",
    title: "回归者的逆袭",
    category: "重生逆袭",
    tags: ["重生", "复仇", "权谋"],
    rating: 8.9,
    status: "连载中",
    latestChapter: "第 152 话",
    updateTime: "今天 12:10 更新",
    views: "1420万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20determined%20young%20man%20in%20modern%20suit%20standing%20confident%20with%20city%20skyline%20behind%2C%20revenge%20drama%20moody%20orange%20and%20charcoal%20tones%2C%20realistic%20drama%20manhwa%20style%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-returner&orientation=portrait",
    intro: "被家族背叛、含恨而终的继承人李承浩，意外重生回到十年前。这一次他藏起锋芒，步步为营，誓要把曾经背叛他的所有人推入深渊，重新夺回属于自己的一切。",
    author: "Kaleido · Jang Soyul",
    chapters: 152,
  },
  {
    id: "secret-studio",
    title: "秘密工作室",
    category: "都市现实",
    tags: ["职场", "成长", "现实"],
    rating: 8.8,
    status: "连载中",
    latestChapter: "第 96 话",
    updateTime: "4 天前更新",
    views: "980万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20focused%20young%20illustrator%20at%20desk%20with%20drawing%20tablet%20and%20cups%2C%20warm%20cozy%20office%20night%20lighting%2C%20earthy%20coral%20and%20brown%20tones%2C%20slice%20of%20life%20manhwa%20style%2C%20vertical%20portrait%20cover&width=420&height=600&seq=cover-studio&orientation=portrait",
    intro: "普通会社员崔智雅梦想成为插画师，白天工作、深夜作画的她，在一次机缘下接手了公司秘密的漫画项目。在理想与现实的拉扯中，她逐渐找到属于自己的创作道路。",
    author: "Ddoyeon · Suho",
    chapters: 96,
  },
  {
    id: "demon-retirement",
    title: "大魔王的退休日常",
    category: "轻松搞笑",
    tags: ["魔王", "日常", "搞笑"],
    rating: 8.7,
    status: "连载中",
    latestChapter: "第 84 话",
    updateTime: "今天 09:45 更新",
    views: "1200万",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20manhwa%20cover%20art%2C%20charming%20demon%20king%20in%20casual%20hoodie%20eating%20noodles%20while%20casting%20small%20fire%20spells%2C%20playful%20comedic%20style%2C%20vibrant%20warm%20coral%20and%20amber%20tones%2C%20funny%20fantasy%20comedy%20cover%2C%20vertical%20portrait&width=420&height=600&seq=cover-demon&orientation=portrait",
    intro: "统治魔界千年的大魔王厌倦了打打杀杀，决定退休来到人间开一间小面馆。可麻烦总是不请自来，昔日的敌人和迷路的勇者接踵而至，让他的退休生活鸡飞狗跳又笑料百出。",
    author: "Gwanryu · Mango",
    chapters: 84,
  },
];

export const shuyuanList: ShuYuan[] = [
  {
    id: "hanman-wu",
    name: "韩漫屋",
    tag: "综合推荐",
    desc: "收录最全、更新最快的韩漫在线阅读站，热门作品当晚上新，支持书架收藏与追更提醒。",
    updateSpeed: "当日更新",
    stability: 98,
    free: true,
    download: true,
    url: "https://hanman-wu.example.com",
    icon: "ri-book-open-line",
  },
  {
    id: "jisu-hanman",
    name: "极速韩漫",
    tag: "流畅稳定",
    desc: "以加载流畅著称的免费韩漫网站，多线路切换缓解高峰期卡顿，漫画画质高清可选。",
    updateSpeed: "同步更新",
    stability: 96,
    free: true,
    download: false,
    url: "https://jisu-hanman.example.com",
    icon: "ri-flashlight-line",
  },
  {
    id: "manhua-dao",
    name: "漫画岛·韩漫",
    tag: "分类精细",
    desc: "韩漫专区分类细致，按题材、人气、完结状态精准筛选，适合按口味找好作品。",
    updateSpeed: "每日更新",
    stability: 93,
    free: true,
    download: true,
    url: "https://manhua-dao.example.com",
    icon: "ri-archive-drawer-line",
  },
  {
    id: "kuaikan-hanman",
    name: "快看韩漫站",
    tag: "新番首发",
    desc: "聚焦新连载与新番首发的韩漫在线阅读站，第一时间跟进韩国本土人气新作。",
    updateSpeed: "首发更新",
    stability: 90,
    free: true,
    download: false,
    url: "https://kuaikan-hanman.example.com",
    icon: "ri-fire-line",
  },
  {
    id: "mianfei-huiji",
    name: "免费韩漫汇",
    tag: "聚合书源",
    desc: "聚合多个免费书源的韩漫导航站，一键跳转多站点对比，彻底解决哪个网站有的难题。",
    updateSpeed: "多源聚合",
    stability: 95,
    free: true,
    download: true,
    url: "https://mianfei-huiji.example.com",
    icon: "ri-stack-line",
  },
  {
    id: "xinhuo-hanman",
    name: "星火韩漫",
    tag: "画质高清",
    desc: "主打高清原画质的韩漫免费网站，支持单页阅读与上下滚动双模式，观感舒适。",
    updateSpeed: "隔日更新",
    stability: 91,
    free: true,
    download: true,
    url: "https://xinhuo-hanman.example.com",
    icon: "ri-sparkling-2-line",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqList: FaqItem[] = [
  {
    q: "好看的韩漫大全哪个网站有免费资源？",
    a: "本站聚合了韩漫屋、极速韩漫、漫画岛·韩漫等多个稳定免费的韩漫在线阅读站书源，你可以在“书源推荐”页查看每个站点的特色、更新速度与稳定性评分，并一键跳转阅读。",
  },
  {
    q: "在韩漫在线阅读站看书需要付费吗？",
    a: "本站推荐的绝大多数书源均为免费在线阅读，热门连载通常免费观看；部分站点对最新话或下载功能设有会员机制。我们会在每个书源卡片上标注“免费”与“支持下载”状态，方便你选择。",
  },
  {
    q: "想追更的韩漫如何第一时间收到提醒？",
    a: "注册登录后，将喜欢的作品加入书架即可开启追更提醒。当作品更新最新话时，你会在“我的追更”中看到更新标记与章节进度，再也不用担心追更迷路。",
  },
  {
    q: "书源不稳定打不开怎么办？",
    a: "每个书源卡片都标注了稳定性评分，建议优先选择评分高、更新快的站点。若某书源临时打不开，可切换到同作品的备用书源；我们也会定期巡检并更新推荐列表。",
  },
  {
    q: "支持下载韩漫离线观看吗？",
    a: "支持。标注“支持下载”的书源可缓存或下载章节，方便在通勤、无网络环境下离线阅读。请遵守相关版权约定，仅用于个人学习与欣赏。",
  },
  {
    q: "如何按题材找到喜欢的好看韩漫？",
    a: "你可以通过顶部“全部韩漫”分类页按热血战斗、奇幻冒险、恋爱治愈、悬疑惊悚等题材筛选，也可以按人气、评分、更新状态排序，快速定位合口味的作品。",
  },
];